import { h, Component } from '@stencil/core';
import { popoverController } from "@ionic/core";


@Component({
  tag: 'tip-info-button'
})
export class TipInfoButton {

  private async openPopover(ev: UIEvent) {
    const options = {
      component: document.createElement('tip-info'),
      ev: ev,
    };
    const popover = await popoverController.create(options);
    await popover.present();
    return popover;
  }

  render() {
    return (
      <ion-button ion-button onClick={(e: UIEvent) => this.openPopover(e)}>
        <ion-icon name="information-circle-outline"></ion-icon>
      </ion-button>
    )
  }
}
